// Copyright 2018 Prescryptive Health, inc

export const settingsStorage = window.localStorage;
